import React, { useState,useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import arrowtopoutline from '../../images/arrow-top-outline.svg';
import saveoutline from '../../images/save-outline.svg';
import heartoutline from '../../images/heart-outline.svg';
import backarrow from '../../images/back-arrow.svg';
import arrow from '../../images/arrow.svg';

import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from "../../constants/apiConstants";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Mousewheel, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination'; 
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

function Details() {
    const { id } = useParams();
    const [property,setProperty] = useState([]);
    const [propertyPhotos,setPropertyPhotos] = useState([]);

    const [imageLength,setImageLength] = useState(0);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    const getProperty = (e) => {
        axios.get(API_BASE_URL+'get/property/'+id,{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setProperty(response.data.data);
            setPropertyPhotos(response.data.data.photos);
        })
        .catch((error) => {
            console.log(error);
        })
    }

    useEffect(()=> {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        getProperty()
    },[]);

    return (
    <>
        <section class="grid_box">
            <div class="container">
                <div class="text_he_box">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-md-6">
                            <div class="d-flex flex-wrap justify-content-between align-items-center">
                                <h4 ><Link to={`/property/${property.id}`}><img src={backarrow} alt="" /></Link> <span className="p-sale">Properties for Sale -</span>  {property.title}</h4>
                                {/* <h4>Verified Developer</h4> */}
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="d-flex flex-wrap justify-content-between align-items-center">
                                <ul>
                                    <li><a href="#">Share <img src={arrowtopoutline} alt="" /></a></li>
                                    <li><a href="#">Save <img src={saveoutline} alt="" /></a></li>
                                    <li><a href="#">Like <img src={heartoutline} alt="" /></a></li>
                                </ul>
                                <Link to={`/property/${property.id}`}><img src={arrow} alt="" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="middle_section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div className="view-property-frame">
                            {propertyPhotos.length > 0  &&
                            <Swiper
                                style={{
                                '--swiper-navigation-color': '#fff',
                                '--swiper-pagination-color': '#fff',
                                }}
                                loop={true}
                                spaceBetween={10}
                                navigation={true}
                                thumbs={{ swiper: thumbsSwiper }}
                                modules={[FreeMode, Navigation, Thumbs,Mousewheel,Pagination]}
                                className="mySwiper3"
                                pagination={{
                                    el: '.custom-pagination',
                                    type: 'custom',
                                    renderCustom: (swiper, current, total) => {
                                    const bullets = Array.from({ length: total }, (_, index) => {
                                        const isActive = index + 1 === current;
                                        return `<span class="custom-bullet ${isActive ? 'active' : ''}"></span>`;
                                    }).join('');
                                    return `
                                        <div class="pagination-container">
                                        <div class="bullets">${bullets}</div>
                                        <div class="d-flex flex-wrap justify-content-between align-items-center text_he_box2">
                                        <h4>${property.description_title}</h4>
                                        <div class="fraction">${current} / ${total}</div>
                                        </div>
                                        </div>
                                    `;
                                    },
                                }}
                                mousewheel={true}
                                >
                                {propertyPhotos.map((item) => (
                                <SwiperSlide>
                                    <img class="box_frame_detail" src={ASSETS_URL+"properties/media/original/"+item} width="100%" alt="" />
                                </SwiperSlide>
                                ))}
                                <div className="custom-pagination"></div>
                            </Swiper>
                            }

                                {/* <img class="box_frame" src={ASSETS_URL+"properties/media/medium/"+property.cover_photo} width="100%" alt="" /> */}

                            {propertyPhotos.length > 0  &&
                            <div class="d-flex photo_gal flex-wrap justify-content-between align-items-center mt-5">
                                <Swiper
                                    onSwiper={setThumbsSwiper}
                                    loop={true}
                                    spaceBetween={30}
                                    slidesPerView={9}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    modules={[FreeMode, Navigation, Thumbs,Mousewheel]}
                                    className="mySwiper1"
                                    mousewheel={true}
                                    breakpoints={{
                                        
                                        320: {
                                        slidesPerView: 3,
                                        },
                                        579: {
                                        slidesPerView: 4,
                                        },
                                        768: {
                                        slidesPerView: 5,
                                        },
                                        1024: {
                                        slidesPerView: 7,
                                        },
                                        1800: {
                                        slidesPerView: 14,
                                        },
                                    }}
                                >
                                {propertyPhotos.map((item) => (
                                    <SwiperSlide>
                                        <img className="property-media-image" src={ASSETS_URL+"properties/media/small/"+item} alt="" width={95} height={95} />
                                    </SwiperSlide>

                                    // <div class="col"> <img className="property-media-image" src={ASSETS_URL+"properties/media/small/"+item} alt="" width={95} height={95} /> </div>
                                ))}
                                </Swiper>
                            </div>
                            }
                        </div>
                    </div>
                  
                </div>
               
            </div>
          
        </section>
      
        <div class="stripbo">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                <span class="border_radius_gredient"></span>
                </div>
                    <h4>Verified Properties - United Arab Emirates - Buy - Properties for Sale - {property.title} - 12011768 </h4>
                </div>
            </div>
        </div>
    </>
    );
}

export default Details;